import React from 'react';
import './homePage.scss';
import {Hero, Footer, Navigation, Help, Industries, Community, News, JoinUs} from "./index";

export const HomePage: React.FC = () => {
    return (
        <div className={'home'}>
            <div className="home_nav">
                <Navigation/>
            </div>
            <Hero/>
            <Help/>
            <Industries/>
            <Community/>
            <JoinUs/>
            <News/>
            <Footer/>
        </div>
    );
};

